import { Component, Input, OnInit } from '@angular/core';
import Swal from 'sweetalert2';
import { DomSanitizer } from '@angular/platform-browser';
import { VideoService } from '../../../services/video.service';
import { StihlVideoDTO } from 'src/app/models/stihl-video-dto';
import { environment } from 'src/environments/environment';
import { TrackingService } from 'src/app/services/tracking.service';

@Component({
  selector: 'app-video',
  templateUrl: './video.component.html'
})

export class VideoComponent implements OnInit {
  @Input() item: string;
  data: StihlVideoDTO;
  pathVideo = environment.urlApiVideos;
  constructor(private videoService: VideoService, private trackService: TrackingService) { }

  ngOnInit(): void {

    this.videoService.get(this.item).subscribe(resp => {
      if (resp.Status) {
        this.data = resp;
      }
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }

  TrackVideo(id: any) {
    this.trackService.trackVideo(id).subscribe();
  }
}
